import styled from "styled-components";

const Container = styled.div`
  float: right;
`;

export default Container;
